import { SPORTS_LIST } from "../bet-config";

export interface BetQLEventStats {
  [key: string]: any;
  period: string | null;
  homeSpreadCount: number | null;
  awaySpreadCount: number | null;
  homeMoneyCount: number | null;
  awayMoneyCount: number | null;
  drawMoneyCount: number | null;
  overCount: number | null;
  underCount: number | null;
  homeSharpSpreadPercent: number | null;
  awaySharpSpreadPercent: number | null;
  homeSharpMoneyPercent: number | null;
  awaySharpMoneyPercent: number | null;
  drawSharpMoneyPercent: number | null;
  overSharpPercent: number | null;
  underSharpPercent: number | null;
  homeTicketSpreadPercent: number | null;
  awayTicketSpreadPercent: number | null;
  homeTicketMoneyPercent: number | null;
  awayTicketMoneyPercent: number | null;
  drawTicketMoneyPercent: number | null;
  overTicketPercent: number | null;
  underTicketPercent: number | null;
  publicMoneyHome: number | null;
  publicMoneyAway: number | null;
  publicMoneyDraw: number | null;
  publicSpreadHome: number | null;
  publicSpreadAway: number | null;
  publicTotalOver: number | null;
  publicTotalUnder: number | null;
}

export const getSharpDisplayValues = (game: any, sport: string) => {
  const currentSportObj = SPORTS_LIST[sport];
  let displayValues: any = {},
    periods: any = {},
    emptyEventStats: BetQLEventStats = {
      period: null,

      homeSpreadCount: null,
      awaySpreadCount: null,
      homeMoneyCount: null,
      awayMoneyCount: null,
      drawMoneyCount: null,
      overCount: null,
      underCount: null,

      homeSharpSpreadPercent: null,
      awaySharpSpreadPercent: null,
      homeSharpMoneyPercent: null,
      awaySharpMoneyPercent: null,
      drawSharpMoneyPercent: null,
      overSharpPercent: null,
      underSharpPercent: null,

      homeTicketSpreadPercent: null,
      awayTicketSpreadPercent: null,
      homeTicketMoneyPercent: null,
      awayTicketMoneyPercent: null,
      drawTicketMoneyPercent: null,
      overTicketPercent: null,
      underTicketPercent: null,

      publicMoneyHome: null,
      publicMoneyAway: null,
      publicMoneyDraw: null,
      publicSpreadHome: null,
      publicSpreadAway: null,
      publicTotalOver: null,
      publicTotalUnder: null,
    };
  currentSportObj.periodKeys.forEach((period: string) => {
    periods[period] = { ...emptyEventStats, period };
    displayValues[`${period}EventStats`] = { ...emptyEventStats, period };
  });
  if (game.eventStats && game.eventStats.length) {
    game.eventStats.forEach((eventStats: BetQLEventStats) => {
      if (eventStats.period) {
        periods[eventStats.period] = eventStats;
        displayValues[`${eventStats.period}EventStats`] = eventStats;
      }
    });
  }
  currentSportObj.periodKeys.forEach((period: string) => {
    displayValues = {
      ...displayValues,
      ...getSharpDataValues(periods[period], period),
    };
  });
  return displayValues;
};

const getSharpDataValues = (eventStats: BetQLEventStats, period: string) => {
  let retValue: any = {};
  retValue[`sharp${period}spreadCountAwayDisplay`] = "--";
  retValue[`sharp${period}spreadCountHomeDisplay`] = "--";
  retValue[`sharp${period}moneylineCountAwayDisplay`] = "--";
  retValue[`sharp${period}moneylineCountHomeDisplay`] = "--";
  retValue[`sharp${period}moneylineCountDrawDisplay`] = "--";
  retValue[`sharp${period}totalCountAwayDisplay`] = "--";
  retValue[`sharp${period}totalCountHomeDisplay`] = "--";

  retValue[`sharp${period}spreadAwayDisplay`] = "--";
  retValue[`sharp${period}spreadHomeDisplay`] = "--";
  retValue[`sharp${period}spreadDisplay`] = "--";
  retValue[`sharp${period}moneylineAwayDisplay`] = "--";
  retValue[`sharp${period}moneylineHomeDisplay`] = "--";
  retValue[`sharp${period}moneylineDrawDisplay`] = "--";
  retValue[`sharp${period}moneylineDisplay`] = "--";
  retValue[`sharp${period}totalHomeDisplay`] = "--";
  retValue[`sharp${period}totalAwayDisplay`] = "--";
  retValue[`sharp${period}totalDisplay`] = "--";

  retValue[`sharp${period}spreadTicketHomeDisplay`] = "--";
  retValue[`sharp${period}spreadTicketAwayDisplay`] = "--";
  retValue[`sharp${period}spreadTicketDisplay`] = "--";
  retValue[`sharp${period}moneylineTicketHomeDisplay`] = "--";
  retValue[`sharp${period}moneylineTicketAwayDisplay`] = "--";
  retValue[`sharp${period}moneylineTicketDrawDisplay`] = "--";
  retValue[`sharp${period}moneylineTicketDisplay`] = "--";
  retValue[`sharp${period}totalTicketHomeDisplay`] = "--";
  retValue[`sharp${period}totalTicketAwayDisplay`] = "--";
  retValue[`sharp${period}totalTicketDisplay`] = "--";

  retValue[`sharp${period}spreadPublicHomeDisplay`] = "--";
  retValue[`sharp${period}spreadPublicAwayDisplay`] = "--";
  retValue[`sharp${period}spreadPublicDisplay`] = "--";
  retValue[`sharp${period}moneylinePublicHomeDisplay`] = "--";
  retValue[`sharp${period}moneylinePublicAwayDisplay`] = "--";
  retValue[`sharp${period}moneylinePublicDrawDisplay`] = "--";
  retValue[`sharp${period}moneylinePublicDisplay`] = "--";
  retValue[`sharp${period}totalPublicHomeDisplay`] = "--";
  retValue[`sharp${period}totalPublicAwayDisplay`] = "--";
  retValue[`sharp${period}totalPublicDisplay`] = "--";

  retValue[`sharp${period}spreadAwayData`] = 0;
  retValue[`sharp${period}spreadHomeData`] = 0;
  retValue[`sharp${period}spreadData`] = 0;
  retValue[`sharp${period}moneylineAwayData`] = 0;
  retValue[`sharp${period}moneylineHomeData`] = 0;
  retValue[`sharp${period}moneylineDrawData`] = 0;
  retValue[`sharp${period}moneylineData`] = 0;
  retValue[`sharp${period}totalHomeData`] = 0;
  retValue[`sharp${period}totalAwayData`] = 0;
  retValue[`sharp${period}totalData`] = 0;

  retValue[`sharp${period}spreadTicketHomeData`] = 0;
  retValue[`sharp${period}spreadTicketAwayData`] = 0;
  retValue[`sharp${period}spreadTicketData`] = 0;
  retValue[`sharp${period}moneylineTicketHomeData`] = 0;
  retValue[`sharp${period}moneylineTicketAwayData`] = 0;
  retValue[`sharp${period}moneylineTicketDrawData`] = 0;
  retValue[`sharp${period}moneylineTicketData`] = 0;
  retValue[`sharp${period}totalTicketHomeData`] = 0;
  retValue[`sharp${period}totalTicketAwayData`] = 0;
  retValue[`sharp${period}totalTicketData`] = 0;

  retValue[`sharp${period}spreadPublicHomeData`] = 0;
  retValue[`sharp${period}spreadPublicAwayData`] = 0;
  retValue[`sharp${period}spreadPublicData`] = 0;
  retValue[`sharp${period}moneylinePublicHomeData`] = 0;
  retValue[`sharp${period}moneylinePublicAwayData`] = 0;
  retValue[`sharp${period}moneylinePublicDrawData`] = 0;
  retValue[`sharp${period}moneylinePublicData`] = 0;
  retValue[`sharp${period}totalPublicHomeData`] = 0;
  retValue[`sharp${period}totalPublicAwayData`] = 0;
  retValue[`sharp${period}totalPublicData`] = 0;

  retValue[`sharp${period}spreadCountAwayData`] = null;
  retValue[`sharp${period}spreadCountHomeData`] = null;
  retValue[`sharp${period}moneylineCountAwayData`] = null;
  retValue[`sharp${period}moneylineCountHomeData`] = null;
  retValue[`sharp${period}moneylineCountDrawData`] = null;
  retValue[`sharp${period}totalCountAwayData`] = null;
  retValue[`sharp${period}totalCountHomeData`] = null;

  retValue[`sharp${period}spreadIsHome`] = undefined;
  retValue[`sharp${period}moneylineIsHome`] = undefined;
  retValue[`sharp${period}totalIsHome`] = undefined;
  retValue[`sharp${period}spreadTicketIsHome`] = undefined;
  retValue[`sharp${period}moneylineTicketIsHome`] = undefined;
  retValue[`sharp${period}totalTicketIsHome`] = undefined;
  retValue[`sharp${period}spreadPublicIsHome`] = undefined;
  retValue[`sharp${period}moneylinePublicIsHome`] = undefined;
  retValue[`sharp${period}totalPublicIsHome`] = undefined;

  if (eventStats) {
    ///////////// START COUNT /////////////
    if (eventStats.awaySpreadCount !== null && eventStats.homeSpreadCount !== null) {
      retValue[`sharp${period}spreadCountAwayData`] = eventStats.awaySpreadCount;
      retValue[`sharp${period}spreadCountHomeData`] = eventStats.homeSpreadCount;
      retValue[`sharp${period}spreadCountAwayDisplay`] = `${eventStats.awaySpreadCount}`;
      retValue[`sharp${period}spreadCountHomeDisplay`] = `${eventStats.homeSpreadCount}`;
    }
    if (eventStats.awayMoneyCount !== null && eventStats.homeMoneyCount !== null) {
      retValue[`sharp${period}moneylineCountAwayData`] = eventStats.awayMoneyCount;
      retValue[`sharp${period}moneylineCountHomeData`] = eventStats.homeMoneyCount;
      retValue[`sharp${period}moneylineCountDrawData`] = eventStats.drawMoneyCount;
      retValue[`sharp${period}moneylineCountAwayDisplay`] = `${eventStats.awayMoneyCount}`;
      retValue[`sharp${period}moneylineCountHomeDisplay`] = `${eventStats.homeMoneyCount}`;
      retValue[`sharp${period}moneylineCountDrawDisplay`] = `${eventStats.drawMoneyCount}`;
    }
    if (eventStats.overCount !== null && eventStats.underCount !== null) {
      retValue[`sharp${period}totalCountAwayData`] = eventStats.overCount;
      retValue[`sharp${period}totalCountHomeData`] = eventStats.underCount;
      retValue[`sharp${period}totalCountAwayDisplay`] = `${eventStats.overCount}`;
      retValue[`sharp${period}totalCountHomeDisplay`] = `${eventStats.underCount}`;
    }
    ///////////// END COUNT /////////////
    ///////////// START SHARP /////////////
    if (eventStats.homeSharpSpreadPercent !== null && eventStats.awaySharpSpreadPercent !== null) {
      retValue[`sharp${period}spreadHomeDisplay`] = eventStats.homeSharpSpreadPercent + "%";
      retValue[`sharp${period}spreadHomeData`] = eventStats.homeSharpSpreadPercent || 0;
      retValue[`sharp${period}spreadAwayDisplay`] = eventStats.awaySharpSpreadPercent + "%";
      retValue[`sharp${period}spreadAwayData`] = eventStats.awaySharpSpreadPercent || 0;
      retValue[`sharp${period}spreadIsHome`] = eventStats.homeSharpSpreadPercent > eventStats.awaySharpSpreadPercent;
      retValue[`sharp${period}spreadDisplay`] = retValue[`sharp${period}spreadIsHome`]
        ? eventStats.homeSharpSpreadPercent + "%"
        : eventStats.awaySharpSpreadPercent + "%";
      retValue[`sharp${period}spreadData`] = retValue[`sharp${period}spreadIsHome`]
        ? eventStats.homeSharpSpreadPercent || 0
        : eventStats.awaySharpSpreadPercent || 0;
    }
    if (eventStats.homeSharpMoneyPercent !== null && eventStats.awaySharpMoneyPercent !== null) {
      retValue[`sharp${period}moneylineHomeDisplay`] = eventStats.homeSharpMoneyPercent + "%";
      retValue[`sharp${period}moneylineHomeData`] = eventStats.homeSharpMoneyPercent || 0;
      retValue[`sharp${period}moneylineAwayDisplay`] = eventStats.awaySharpMoneyPercent + "%";
      retValue[`sharp${period}moneylineAwayData`] = eventStats.awaySharpMoneyPercent || 0;
      retValue[`sharp${period}moneylineDrawDisplay`] = eventStats.drawSharpMoneyPercent + "%";
      retValue[`sharp${period}moneylineDrawData`] = eventStats.drawSharpMoneyPercent || 0;
      const list = [eventStats.awaySharpMoneyPercent, eventStats.homeSharpMoneyPercent];
      if (eventStats.drawSharpMoneyPercent !== null) {
        list.push(eventStats.drawSharpMoneyPercent);
      }
      // if all the sharp values are equal then there is no edge
      const equal = list.every((stat) => stat === list[0]);
      if (!equal) {
        const index = list.indexOf(Math.max(...list));
        switch (index) {
          case 0:
            retValue[`sharp${period}moneylineIsHome`] = false;
            retValue[`sharp${period}moneylineDisplay`] = eventStats.awaySharpMoneyPercent + "%";
            retValue[`sharp${period}moneylineData`] = eventStats.awaySharpMoneyPercent || 0;
            break;
          case 1:
            retValue[`sharp${period}moneylineIsHome`] = true;
            retValue[`sharp${period}moneylineDisplay`] = eventStats.homeSharpMoneyPercent + "%";
            retValue[`sharp${period}moneylineData`] = eventStats.homeSharpMoneyPercent || 0;
            break;
          case 2:
            retValue[`sharp${period}moneylineIsHome`] = null;
            retValue[`sharp${period}moneylineDisplay`] = eventStats.drawSharpMoneyPercent + "%";
            retValue[`sharp${period}moneylineData`] = eventStats.drawSharpMoneyPercent || 0;
            break;
        }
      }
    }
    if (eventStats.overSharpPercent !== null && eventStats.underSharpPercent !== null) {
      retValue[`sharp${period}totalAwayDisplay`] = eventStats.overSharpPercent + "%";
      retValue[`sharp${period}totalAwayData`] = eventStats.overSharpPercent || 0;
      retValue[`sharp${period}totalHomeDisplay`] = eventStats.underSharpPercent + "%";
      retValue[`sharp${period}totalHomeData`] = eventStats.underSharpPercent || 0;
      retValue[`sharp${period}totalIsHome`] = eventStats.underSharpPercent > eventStats.overSharpPercent;
      retValue[`sharp${period}totalDisplay`] = retValue[`sharp${period}totalIsHome`]
        ? eventStats.underSharpPercent + "%"
        : eventStats.overSharpPercent + "%";
      retValue[`sharp${period}totalData`] = retValue[`sharp${period}totalIsHome`]
        ? eventStats.underSharpPercent || 0
        : eventStats.overSharpPercent || 0;
    }
    ///////////// END SHARP /////////////
    ///////////// START TICKETS /////////////
    if (
      eventStats.homeTicketSpreadPercent !== null &&
      eventStats.homeTicketSpreadPercent >= 0 &&
      eventStats.awayTicketSpreadPercent !== null &&
      eventStats.awayTicketSpreadPercent >= 0
    ) {
      retValue[`sharp${period}spreadTicketHomeDisplay`] = eventStats.homeTicketSpreadPercent + "%";
      retValue[`sharp${period}spreadTicketHomeData`] = eventStats.homeTicketSpreadPercent || 0;
      retValue[`sharp${period}spreadTicketAwayDisplay`] = eventStats.awayTicketSpreadPercent + "%";
      retValue[`sharp${period}spreadTicketAwayData`] = eventStats.awayTicketSpreadPercent || 0;
      retValue[`sharp${period}spreadTicketIsHome`] =
        eventStats.homeTicketSpreadPercent > eventStats.awayTicketSpreadPercent;
      retValue[`sharp${period}spreadTicketDisplay`] = retValue[`sharp${period}spreadTicketIsHome`]
        ? eventStats.homeTicketSpreadPercent + "%"
        : eventStats.awayTicketSpreadPercent + "%";
      retValue[`sharp${period}spreadTicketData`] = retValue[`sharp${period}spreadTicketIsHome`]
        ? eventStats.homeTicketSpreadPercent || 0
        : eventStats.awayTicketSpreadPercent || 0;
    }
    if (
      eventStats.homeTicketMoneyPercent !== null &&
      eventStats.homeTicketMoneyPercent >= 0 &&
      eventStats.awayTicketMoneyPercent !== null &&
      eventStats.awayTicketMoneyPercent >= 0
    ) {
      retValue[`sharp${period}moneylineTicketHomeDisplay`] = eventStats.homeTicketMoneyPercent + "%";
      retValue[`sharp${period}moneylineTicketHomeData`] = eventStats.homeTicketMoneyPercent || 0;
      retValue[`sharp${period}moneylineTicketAwayDisplay`] = eventStats.awayTicketMoneyPercent + "%";
      retValue[`sharp${period}moneylineTicketAwayData`] = eventStats.awayTicketMoneyPercent || 0;
      retValue[`sharp${period}moneylineTicketDrawDisplay`] = eventStats.drawTicketMoneyPercent + "%";
      retValue[`sharp${period}moneylineTicketDrawData`] = eventStats.drawTicketMoneyPercent || 0;
      const list = [eventStats.awayTicketMoneyPercent, eventStats.homeTicketMoneyPercent];
      if (eventStats.drawTicketMoneyPercent !== null && eventStats.drawTicketMoneyPercent >= 0) {
        list.push(eventStats.drawTicketMoneyPercent);
      }
      const index = list.indexOf(Math.max(...list));
      switch (index) {
        case 0:
          retValue[`sharp${period}moneylineTicketIsHome`] = false;
          retValue[`sharp${period}moneylineTicketDisplay`] = eventStats.awayTicketMoneyPercent + "%";
          retValue[`sharp${period}moneylineTicketData`] = eventStats.awayTicketMoneyPercent || 0;
          break;
        case 1:
          retValue[`sharp${period}moneylineTicketIsHome`] = true;
          retValue[`sharp${period}moneylineTicketDisplay`] = eventStats.homeTicketMoneyPercent + "%";
          retValue[`sharp${period}moneylineTicketData`] = eventStats.homeTicketMoneyPercent || 0;
          break;
        case 2:
          retValue[`sharp${period}moneylineTicketIsHome`] = null;
          retValue[`sharp${period}moneylineTicketDisplay`] = eventStats.drawTicketMoneyPercent + "%";
          retValue[`sharp${period}moneylineTicketData`] = eventStats.drawTicketMoneyPercent || 0;
          break;
      }
    }
    if (
      eventStats.overTicketPercent !== null &&
      eventStats.overTicketPercent >= 0 &&
      eventStats.underTicketPercent !== null &&
      eventStats.underTicketPercent >= 0
    ) {
      retValue[`sharp${period}totalTicketAwayDisplay`] = eventStats.overTicketPercent + "%";
      retValue[`sharp${period}totalTicketAwayData`] = eventStats.overTicketPercent || 0;
      retValue[`sharp${period}totalTicketHomeDisplay`] = eventStats.underTicketPercent + "%";
      retValue[`sharp${period}totalTicketHomeData`] = eventStats.underTicketPercent || 0;
      retValue[`sharp${period}totalTicketIsHome`] = eventStats.underTicketPercent > eventStats.overTicketPercent;
      retValue[`sharp${period}totalTicketDisplay`] = retValue[`sharp${period}totalTicketIsHome`]
        ? eventStats.underTicketPercent + "%"
        : eventStats.overTicketPercent + "%";
      retValue[`sharp${period}totalTicketData`] = retValue[`sharp${period}totalTicketIsHome`]
        ? eventStats.underTicketPercent || 0
        : eventStats.overTicketPercent || 0;
    }
    ///////////// END TICKETS /////////////
    ///////////// START PUBLIC /////////////
    if (eventStats.publicSpreadHome !== null) {
      retValue[`sharp${period}spreadPublicHomeDisplay`] = eventStats.publicSpreadHome + "%";
      retValue[`sharp${period}spreadPublicHomeData`] = eventStats.publicSpreadHome || 0;
    }
    if (eventStats.publicSpreadAway !== null) {
      retValue[`sharp${period}spreadPublicAwayDisplay`] = eventStats.publicSpreadAway + "%";
      retValue[`sharp${period}spreadPublicAwayData`] = eventStats.publicSpreadAway || 0;
    }
    if (
      eventStats.publicSpreadHome !== null &&
      eventStats.publicSpreadAway !== null &&
      eventStats.publicSpreadHome >= 0 &&
      eventStats.publicSpreadAway >= 0
    ) {
      retValue[`sharp${period}spreadPublicIsHome`] = eventStats.publicSpreadHome > eventStats.publicSpreadAway;
      retValue[`sharp${period}spreadPublicDisplay`] = retValue[`sharp${period}spreadPublicIsHome`]
        ? eventStats.publicSpreadHome + "%"
        : eventStats.publicSpreadAway + "%";
      retValue[`sharp${period}spreadPublicData`] = retValue[`sharp${period}spreadPublicIsHome`]
        ? eventStats.publicSpreadHome || 0
        : eventStats.publicSpreadAway || 0;
    }
    if (eventStats.publicMoneyHome !== null) {
      retValue[`sharp${period}moneylinePublicHomeDisplay`] = eventStats.publicMoneyHome + "%";
      retValue[`sharp${period}moneylinePublicHomeData`] = eventStats.publicMoneyHome || 0;
    }
    if (eventStats.publicMoneyAway !== null) {
      retValue[`sharp${period}moneylinePublicAwayDisplay`] = eventStats.publicMoneyAway + "%";
      retValue[`sharp${period}moneylinePublicAwayData`] = eventStats.publicMoneyAway || 0;
    }
    if (eventStats.publicMoneyDraw !== null) {
      retValue[`sharp${period}moneylinePublicDrawDisplay`] = eventStats.publicMoneyDraw + "%";
      retValue[`sharp${period}moneylinePublicDrawData`] = eventStats.publicMoneyDraw || 0;
    }
    if (
      eventStats.publicMoneyHome !== null &&
      eventStats.publicMoneyAway !== null &&
      eventStats.publicMoneyHome >= 0 &&
      eventStats.publicMoneyAway >= 0
    ) {
      const list = [eventStats.publicMoneyAway, eventStats.publicMoneyHome];
      if (eventStats.publicMoneyDraw !== null && eventStats.publicMoneyDraw >= 0) {
        list.push(eventStats.publicMoneyDraw);
      }
      const index = list.indexOf(Math.max(...list));
      switch (index) {
        case 0:
          retValue[`sharp${period}moneylinePublicIsHome`] = false;
          retValue[`sharp${period}moneylinePublicDisplay`] = eventStats.publicMoneyAway + "%";
          retValue[`sharp${period}moneylinePublicData`] = eventStats.publicMoneyAway || 0;
          break;
        case 1:
          retValue[`sharp${period}moneylinePublicIsHome`] = true;
          retValue[`sharp${period}moneylinePublicDisplay`] = eventStats.publicMoneyHome + "%";
          retValue[`sharp${period}moneylinePublicData`] = eventStats.publicMoneyHome || 0;
          break;
        case 2:
          retValue[`sharp${period}moneylinePublicIsHome`] = null;
          retValue[`sharp${period}moneylinePublicDisplay`] = eventStats.publicMoneyDraw + "%";
          retValue[`sharp${period}moneylinePublicData`] = eventStats.publicMoneyDraw || 0;
          break;
      }
    }
    if (eventStats.publicTotalOver !== null) {
      retValue[`sharp${period}totalPublicAwayDisplay`] = eventStats.publicTotalOver + "%";
      retValue[`sharp${period}totalPublicAwayData`] = eventStats.publicTotalOver || 0;
    }
    if (eventStats.publicTotalUnder !== null) {
      retValue[`sharp${period}totalPublicHomeDisplay`] = eventStats.publicTotalUnder + "%";
      retValue[`sharp${period}totalPublicHomeData`] = eventStats.publicTotalUnder || 0;
    }
    if (
      eventStats.publicTotalOver !== null &&
      eventStats.publicTotalUnder !== null &&
      eventStats.publicTotalOver >= 0 &&
      eventStats.publicTotalUnder >= 0
    ) {
      retValue[`sharp${period}totalPublicIsHome`] = eventStats.publicTotalUnder > eventStats.publicTotalOver;
      retValue[`sharp${period}totalPublicDisplay`] = retValue[`sharp${period}totalPublicIsHome`]
        ? eventStats.publicTotalUnder + "%"
        : eventStats.publicTotalOver + "%";
      retValue[`sharp${period}totalPublicData`] = retValue[`sharp${period}totalPublicIsHome`]
        ? eventStats.publicTotalUnder || 0
        : eventStats.publicTotalOver || 0;
    }
    ///////////// END PUBLIC /////////////
  }
  return retValue;
};

export const getSharpData = (game: any, filter: string) => {
  const periodFilter = filter === "spread" || filter === "moneyline" || filter === "total" ? `FG${filter}` : filter;
  return game[`sharp${periodFilter}Data`];
};

export const getSharpAbbrev = (game: any, filter: string) => {
  const { homeTeam, awayTeam } = game;
  const periodFilter = filter === "spread" || filter === "moneyline" || filter === "total" ? `FG${filter}` : filter;
  switch (filter) {
    case "total":
      return game[`sharp${periodFilter}IsHome`] ? "Under" : "Over";
    default:
      return game[`sharp${periodFilter}IsHome`] ? homeTeam.preferredAbbreviation : awayTeam.preferredAbbreviation;
  }
};
